export default __webpack_public_path__ + "6cb51067d8455344523f2b1a8f548330.png";